import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  educationLength: 0,
  education: [],
}

export default function educationReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EDUCATION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_EDUCATION:
      return {...state, saveLoader: action.payload}
    case actions.GET_EDUCATION:
      return {...state, education: action.payload.education, educationLength: action.payload.educationLength}
    default:
      return {...state};
  }
}